import React, { useRef, useCallback } from 'react';
import { Panel, PanelType } from '@fluentui/react';
import { useHelp } from '../context/HelpContext';
import { useAuth } from '../context/AuthContext';
import { HandbuchContent, S } from './HandbuchContent';

export const HelpPanel: React.FC = () => {
  const { manualOpen, closeManual } = useHelp();
  const { user } = useAuth();
  const p = user?.permissions;
  const isPrivileged = !!(p?.isAdmin || p?.isEinkauf || p?.isGeschaeftsfuehrer);
  const scrollRef = useRef<HTMLDivElement>(null);

  const scrollTo = useCallback((id: string) => {
    const el = scrollRef.current?.querySelector(`#${id}`);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  return (
    <Panel
      isOpen={manualOpen}
      onDismiss={closeManual}
      type={PanelType.custom}
      customWidth="840px"
      headerText="Bestellwesen – Bedienungshandbuch"
      isLightDismiss
      styles={{
        header: { paddingLeft: 32, background: 'linear-gradient(135deg, #0078d4, #004578)', color: 'white' },
        headerText: { color: 'white', fontWeight: 300, fontSize: 20 },
        closeButton: { color: 'white', selectors: { ':hover': { color: 'white', background: 'rgba(255,255,255,0.15)' } } },
        content: { padding: 0 },
        scrollableContent: { overflow: 'hidden' },
      }}
    >
      {/* PDF-Link über dem Inhaltsverzeichnis */}
      <div style={{ padding: '12px 32px 0', display: 'flex', justifyContent: 'flex-end' }}>
        <a
          href="/handbuch"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            fontSize: 13,
            color: '#0078d4',
            textDecoration: 'none',
            padding: '4px 10px',
            border: '1px solid #0078d4',
            borderRadius: 2,
            fontFamily: '"Segoe UI", sans-serif',
          }}
          title="Handbuch als PDF drucken / speichern"
        >
          🖨 Als PDF öffnen
        </a>
      </div>

      <div ref={scrollRef} style={{ height: 'calc(100vh - 130px)', overflowY: 'auto' }}>
        <div style={S.scrollArea}>
          <HandbuchContent scrollTo={scrollTo} isPrivileged={isPrivileged} />
        </div>
      </div>
    </Panel>
  );
};
